<template>
    <div class="investMonitor">
		<leftnav class="fl" mkcode="B" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
                <div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
					<monitorComponent :type="navValue" v-show="navValue != 4"></monitorComponent>



				</div>
				<div class="whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="py-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
								<th>序号</th>
                                <th>行政区</th>
								<th>项目名称</th>
								<th>筛选条件</th>
                                <th>总面积(亩)</th>
                                <th>土地用途</th>
                                <th>土地使用权人（项目公司）</th>
								<th>投资主体</th>
                                <th >签订日期</th>
                                <th >操作</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.region}}</td>
                                <td class="title" @click="handlerLinkLocal('/landDetail?id='+item.id+'&pageType=2')">{{item.projectname}}</td>
                                <td> <el-rate v-model="item.rate" :colors="['#333','#333','#333']" :disabled="true" ></el-rate></td>
                                <td>{{item.totalarea}}</td>
                                
                                <td>{{item.landuse}}</td>
                                <td class="title" @click="routerlinkid('/enterprises?id='+item.stockcode)">{{item.company}}</td>
                                <td class="title" @click="routerlinkid('/enterprises?id='+item.stockcode)">{{item.investor}}</td>
                                <td>{{item.signDate}}</td>
                                <td class="collectfont1">
                                    <span @click="delClue(item)">加入线索管理</span>
                                </td>
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script> 
import { mapState, mapMutations, mapGetters } from "vuex";
import monitorComponent from "./inc/monitor.vue";
export default {
    name: 'investMonitor',
    components: {
        monitorComponent,
    },
    computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
    data() {
        return {
            userdata: {},
            page: 1,
            haspage: true,
            pageSize: 10,
            total: 0,
            totalPage: 1,
            maxPage: 10,
            yj_itemcode: "A01",
            navList: [{value: 1, label: '全面监测'},{value: 2, label: '重点行业监测'},{value: 3, label: '重点企业类型监测'},{value: 4, label: '监测线索管理'}],
            navValue: 1,
            enterpristlist: [{
                col:1,
                stockcode: '1',
                region: '河北省秦皇岛市',
                projectname: '秦皇岛海港区盛步储能技术有限公司',
                totalarea: '44.72', 
                landuse: '仓储用地', 
                company: '秦皇岛海港区盛步储能技术有限公司', 
                investor: '晶科电力有限公司', 
                source: '浙江省嘉兴市', 
                signDate: '2025-11-25' ,
                rate: 4,
                }],
        };
    },
    methods: {
        ajaxsearchcompany(page) {
            console.log('ajaxsearchcompany', page);
        },
        delClue(item) {
            console.log('移除线索管理', item);
        },
        pageHandler(page) {
            this.page = page;
            // this.ajaxsearchcompany(page);
        },
    },
};
</script>
<style>
.clueManagement .whitebox{
    min-height: 95vh;
}
</style>